export function pageTitle(title: string): string {
	return `${title} | Phadonia`;
}
